/**
 * Comment Action Types (Emote Upgrade — STATE-002)
 *
 * All comment state is now scoped by videoId to prevent cross-video data bleed (REQ-026).
 * Supports typed comments (normal/valued/insight/challenge), threading, and delete.
 */
export const CommentTypes = {
  // ── Fetch comments (scoped by videoId + optional filters) ──
  FETCH_COMMENTS_REQUEST: 'FETCH_COMMENTS_REQUEST',
  FETCH_COMMENTS_SUCCESS: 'FETCH_COMMENTS_SUCCESS',
  FETCH_COMMENTS_FAILURE: 'FETCH_COMMENTS_FAILURE',

  // ── Add typed comment ──────────────────────────────────────
  ADD_COMMENT_REQUEST: 'ADD_COMMENT_REQUEST',
  ADD_COMMENT_SUCCESS: 'ADD_COMMENT_SUCCESS',
  ADD_COMMENT_FAILURE: 'ADD_COMMENT_FAILURE',

  // ── Delete comment (REQ-039, REQ-040) ──────────────────────
  DELETE_COMMENT_REQUEST: 'DELETE_COMMENT_REQUEST',
  DELETE_COMMENT_SUCCESS: 'DELETE_COMMENT_SUCCESS',
  DELETE_COMMENT_FAILURE: 'DELETE_COMMENT_FAILURE',

  // ── Edit comment (5-min window — Phase 3 Step 3.3) ────────
  EDIT_COMMENT_REQUEST: 'EDIT_COMMENT_REQUEST',
  EDIT_COMMENT_SUCCESS: 'EDIT_COMMENT_SUCCESS',
  EDIT_COMMENT_FAILURE: 'EDIT_COMMENT_FAILURE',

  // ── Pagination (scoped by videoId — REQ-035) ───────────────
  CHANGE_COMMENTS_PAGE: 'CHANGE_COMMENTS_PAGE',

  // ── Modal control (REQ-020, REQ-025) ───────────────────────
  SHOW_COMMENTS_MODAL: 'SHOW_COMMENTS_MODAL',   // payload: { videoId, preSelectedTab }
  HIDE_COMMENTS_MODAL: 'HIDE_COMMENTS_MODAL',

  // ── Active video ───────────────────────────────────────────
  SET_ACTIVE_VIDEO_ID: 'SET_ACTIVE_VIDEO_ID',

  // ── Reset (scoped or global) ───────────────────────────────
  RESET_COMMENTS: 'RESET_COMMENTS',

  // ── Toast (kept for legacy compat, may remove later) ───────
  SHOW_TOAST: 'SHOW_TOAST'
};
